import { render, staticRenderFns } from "./ai-question.vue?vue&type=template&id=72103f70&lang=pug&"
import script from "./ai-question.vue?vue&type=script&lang=js&"
export * from "./ai-question.vue?vue&type=script&lang=js&"
import style0 from "./ai-question.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports